import {
  InitClient,
  GetByParas,
  Post,
  PostWithParas,
  PostNoParas,
} from "../ZeusAPIClient.js";
import { apiConfig } from "../../config.js";
import { PagingBody } from "../Model/PagingBody";
import { Predicate } from "../Model/Predicate";

InitClient(apiConfig.clientId, apiConfig.clientSecret, apiConfig.host);

//获取单个用户信息
async function GetSingeleUser(id, refer) {
  var data = {
    id: id,
  };
  return await GetByParas("04f60fa4-d819-441c-9af5-2daec42150fa", data);
}

//获取单个用户薪资基本信息
async function GetUserSalaryDetails(id) {
  var data = {
    id: id,
  };
  return await GetByParas("24cf17f0-90e8-47cc-acc4-dd9dbc57bd37", data);
}
//获取用户基本信息
async function GeteUserBaseList(predicates) {
  var data = {};
  return await PostWithParas(
    "1A242678-58D0-448B-9E51-36E3A99933B3",
    data,
    predicates
  );
}

//获取用户联系信息
async function GetUserContactList(predicates) {
  var data = {};
  return await PostWithParas(
    "C72D675F-D0B3-4710-88EB-7EA141A98150",
    data,
    predicates
  );
}

//获取用户合同信息
async function GetUserContractList(predicates) {
  var data = {};
  return await PostWithParas(
    "02CA279C-2061-40EF-9482-AD7BC37D7C37",
    data,
    predicates
  );
}

//获取用户教育信息
async function GetUseEducationList(predicates) {
  var data = {};
  return await PostWithParas(
    "42EDC5AE-0914-473A-A92D-52B2BFC64E8E",
    data,
    predicates
  );
}

//获取用户紧急联系人信息
async function GetUseEmergencyList(predicates) {
  var data = {};
  return await PostWithParas(
    "DDFE3955-62F6-4D73-9F94-7E389300EA2D",
    data,
    predicates
  );
}

//获取用户家庭信息
async function GetUseFamilyList(predicates) {
  var data = {};
  return await PostWithParas(
    "34FE2E5B-6BAE-49AA-9423-C1D771E6EC14",
    data,
    predicates
  );
}

//获取用户资质信息
async function GetUseQualificationList(predicates) {
  var data = {};
  return await PostWithParas(
    "E9C0FA4B-DF0C-41B6-AF99-2DFA6BEF6D5A",
    data,
    predicates
  );
}

//获取用户工作经历列表信息
async function GetUseWorkHistoryList(predicates) {
  var data = {};
  return await PostWithParas(
    "06ED6376-F7CA-4450-9F51-76737369E3C8",
    data,
    predicates
  );
}
//获取所有部门信息
async function GetAllFrame() {
  var paras = {};
  return await GetByParas("91f6cd99-11a0-4afd-9c20-8aff3b91f9f6", paras);
}
//获取所有部门控件值
 function GetAllFrameOptions(frames, parentId) {
  var options = [];
//   console.log(frames)
  var f = frames.filter((p) => p.ParentId == parentId);
//   console.log(f)
  f = sortFrame(f);
//   console.log(f)
  if (f.length > 0) {
    f.forEach((element) => {
      var option = {};
      option.label = element.ClassName;
      option.id = element.Id;
      if (parentId) {
        option.pid = parentId;
      } else {
        option.pid = "0";
      }
      var children = frames.filter((p) => p.ParentId == element.Id);
      if (children.length > 0) {
        option.children = GetAllFrameOptions(frames, element.Id);
      }
      else
      {
          option.children=[];
      }
      options.push(option);
    });
  }
  return options;
}
//排序部门
function sortFrame(frames) {
  return frames.sort(function(a, b) {
    var x = a.Sort;
    var y = b.Sort;
    return x < y ? -1 : x > y ? 1 : 0;
  });
}
//获取所有部门和人员信息
async function GetAllFrameAndUser() {
  var paras = {};
  return await GetByParas("addca34b-c03c-466f-87e6-209e080bec74", paras);
}
//获取所有部门人员控件值
async function GetAllFrameAndUserOptions(framesAndUsers, parentId) {
  var options = [];
  var f = framesAndUsers.filter((p) => p.ParentId == parentId);
  f = sortFrame(f);
  if (f.length > 0) {
    f.forEach((element) => {
      var option = {};
      option.label = element.ClassName;
      option.value = element.Id;
      option.type="frame";
      if (parentId) {
        option.pid = parentId;
      } else {
        option.pid = "0";
      }
      var children = frames.filter((p) => p.ParentId == element.Id);
      if (children.length + element.UserList.length > 0) {
        option.children = [];
        option.children.concat(GetAllFrameOptions(framesAndUsers, element.Id));
        if (element.UserList.length > 0) {
          option.children.concat(GetUsersOption(element.UserList));
        }
      }
      options.push(option);
    });
  }
  return options;
}
//获取所有部门人员控件值
async function GetAllFUOptions() {
  var frames = await GetAllFrameAndUser();
  return GetAllFrameAndUserOptions(frames);
}
//获取所有部门控件值
async function GetAllFOptions() {
  var frames = await GetAllFrame();
  return GetAllFrameOptions(frames, "");
}
//获取人员控件值
async function GetUsersOption(users, parentId) {
  var options = [];
  if (users.length > 0) {
    users.forEach((element) => {
      var option = {};
      option.label = element.TrueName;
      option.value = element.Id;
      option.pid = parentId;
      option.type="user";
      options.push(option);
    });
  }
  return options;
}
//根据父级ID获取部门列表
async function GetFrameByParentId(parentId) {
  if (!parentId) {
    parentId = "09308a98-76a5-4fd8-b810-ddd76d37fe4b";
  }
  var predicates = [];
  predicates.push(new Predicate("ParentId", parentId, "eq", 1));
  predicates.push(new Predicate("IsDelete", 0, "eq", 1));
  return await Post("ee823424-8940-4305-bb32-428af243fbc4", predicates);
}
//根据部门ID获取部门下所有岗位
async function GetDutysByFrameId(frameId) {
  var paras = {
    mainid: frameId,
  };
  return await GetByParas("9cd868b2-c0c7-4b31-99bb-cb98bbcdbdc0", paras);
}

//获取单个岗位信息 ea6daf4f-1d99-458c-9b4b-c4134976f988
async function GetDutysDetail(id){
  var paras = {
    id: id
  };
  return await GetByParas("ea6daf4f-1d99-458c-9b4b-c4134976f988", paras);
}

//根据parentid获取包括当前部门及当前部门下所有部门
async function GetFrameListByPid(parentId) {
  //
  var paras = {
    parentid: parentId,
  };
  return await GetByParas("e0e743e4-ce52-400a-b862-474391774e8c", paras);
}

async function GetUserByParentId(parentId) {
  var predicates = [];
  predicates.push(new Predicate("MainDeptsID", parentId, "eq", 1));
  predicates.push(new Predicate("IsDel", "false", "eq", 1));
  var pb = new PagingBody(predicates, 1, 100, "TrueName", "asc");
  return await Post("db8253f5-b8cb-4bae-9f59-cf3e2f57f764", pb);
}
async function GetFrameById(frameId) {
  var predicates = [];
  predicates.push(new Predicate("Id", frameId, "eq", 1));
  // predicates.push(new Predicate('IsDelete','0','eq',1));
  return await GetFramesByWhere(predicates);
}
async function GetFrameByName(name) {
    var predicates = [];
    predicates.push(new Predicate("ClassName", name, "contain", 1));
    // predicates.push(new Predicate('IsDelete','0','eq',1));
    return await GetFramesByWhere(predicates);
  }
async function GetFramesByWhere(predicates) {
  return await Post("ee823424-8940-4305-bb32-428af243fbc4", predicates);
}
//验证信息唯一性
async function CheckUserBaseFiledOnly(predicates) {
  var flag = false;
  var data = {};

  //获取userbase列表
  var userbaselist = await PostWithParas(
    "1A242678-58D0-448B-9E51-36E3A99933B3",
    data,
    predicates
  );

  //判断是否存在信息
  if (userbaselist.length > 0) {
    flag = true;
  }

  return flag;
}

//检查员工信息唯一性
async function CheckUserFiledOnly(predicates) {
  var flag = false;
  var data = {};
  //获取user列表
  var userlist = await PostWithParas(
    "9cdc26de-170b-4e84-8516-b10b852fa575",
    data,
    predicates
  );
  //判断是否存在信息
  if (userlist.length > 0) {
    flag = true;
  }

  return flag;
}

//根据身份证号获取出生年月
function GetBirthday(idNum) {
  var birthday = "1900-01-01";
  if (idNum.length == 18) {
    var yyyy = idNum.substring(6, 10);
    var month = idNum.substring(10, 12);
    var day = idNum.substring(12, 14);
    birthday = yyyy + "-" + month + "-" + day;
    return birthday;
  } else {
    return birthday;
  }
}

//根据身份证号获取性别
function GetGender(idNum) {
  var gender = 0;
  if (idNum.length == 18) {
    var xs = idNum.substring(16, 17);
    gender = xs % 2;
    return gender;
  } else {
    return gender;
  }
}
async function GetUserByName(name)
{
  var predicates=[];
  predicates.push(new Predicate("TrueName",name,"contain",1));
  predicates.push(new Predicate("IsDel","false","eq",1));
  return await GetUserViewPageBywhere(predicates);
}
async function GetUserViewPageBywhere(predicates,size=20)
{
  var body=new PagingBody();
  body.Predicates = predicates;
  body.PageIndex = 1;
  body.PageSize = size;
  body.OrderBy = "TrueName";
  body.Sort = "asc";
  return await Post("db8253f5-b8cb-4bae-9f59-cf3e2f57f764",body);
}
//更新员工档案信息
async function UpdateFullUser(fullUser) {
  //26e83b9f-0628-4655-98bc-505f7d579b62
  var data = await Post("26e83b9f-0628-4655-98bc-505f7d579b62", fullUser); //await PostWithParas('26e83b9f-0628-4655-98bc-505f7d579b62',fullUser,'')
  data = data.replace('"', "");
  if (data == "success") {
    return true;
  } else {
    return false;
  }
}

//员工信息导出  开始

//员工信息导出列表
async function SysUserAllList(pageIndex,pageSize,status,userId,roleKey,startTime,endTime) {
  var para={
    userId:userId,//当前登录了人id
    roleKey:roleKey,//当前登录人角色
    status:status,//状态 1离职 2入职 3在职
    p:pageIndex,
    size:pageSize,
  }
  var data = {
    startTime:startTime,//开始时间
    endTime:endTime//结束时间
  };
  return await PostWithParas("6351c81b-58f6-4e12-b057-62a5420ab250",para,data);
}

//导出离职人员信息 d08d9fc6-cdd1-48ff-b719-838e90e9f875
async function ExportedLeaveList(startTime,endTime,roleKey){
  var paras = {
    startTime:startTime,
    endTime:endTime,
    roleKey:roleKey
  };
  return await PostWithParas("d08d9fc6-cdd1-48ff-b719-838e90e9f875",paras,'');
} 
//员工信息导出  结束

export {
  GetSingeleUser,
  GeteUserBaseList,
  GetUserContactList,
  GetUserContractList,
  GetUseEducationList,
  GetUseEmergencyList,
  GetUseFamilyList,
  GetUseQualificationList,
  GetUseWorkHistoryList,
  CheckUserBaseFiledOnly,
  CheckUserFiledOnly,
  GetBirthday,
  GetGender,
  UpdateFullUser,
  GetAllFrame,
  GetAllFrameAndUser,
  GetFrameByParentId,
  GetAllFUOptions,
  GetAllFOptions,
  GetUserByParentId,
  GetFrameById,
  GetDutysByFrameId,
  GetFrameListByPid,
  GetFrameByName,
  GetUserByName,
  GetUserSalaryDetails,
  GetDutysDetail,
  SysUserAllList,
  ExportedLeaveList
};
